import { ButtonBase, Paper, Stack, Typography, useTheme } from "@mui/material";
import IconCircleWrapper from "../../../ui/IconCircleWrapper";
import { CaretRightIcon } from "../../../ui/icons";

interface TransactionTypeSelectorButtonProps {
  label: string;
  icon: React.ReactNode;
  bgColor: string;
  iconColor?: string;
  disabled?: boolean;
  isSelected?: boolean;
  placeholder?: string;
  onClick: () => void;
  onMouseDown?: () => void;
}

const TransactionTypeSelectorButton = ({
  label,
  icon,
  bgColor,
  iconColor,
  disabled = false,
  isSelected = false,
  placeholder = "Loại giao dịch",
  onClick,
  onMouseDown,
}: TransactionTypeSelectorButtonProps) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <ButtonBase
        sx={{
          p: 2,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        }}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onTouchStart={onMouseDown}
        disabled={disabled}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <IconCircleWrapper
            size={40}
            color={iconColor || theme.palette.common.white}
            bgcolor={bgColor}
          >
            {icon}
          </IconCircleWrapper>
          <Typography variant="body1" color="text.secondary">
            {placeholder}
          </Typography>
        </Stack>
        {isSelected ? (
          <Typography variant="h3" color="text.primary">
            {label}
          </Typography>
        ) : (
          <CaretRightIcon style={{ fontSize: 24, color: theme.palette.text.secondary }} />
        )}
      </ButtonBase>
    </Paper>
  );
};

export default TransactionTypeSelectorButton;
